import { Spin, SpinProps } from "antd";

const Preloader = (props: SpinProps) => {
  return <Spin {...props}>{props.children}</Spin>;
};

export default Preloader;
